import moment from "moment";
import type { Chat } from "../Models/Chat";

type CategorizedChat = Pick<
    Chat,
    "id" | "createdOn" | "isKboFlowResearch"
>;

export function categorizeChats<T extends { chat: CategorizedChat }>(
    chatStores: Iterable<T>,
    visibleChatIds: readonly string[],
    now: moment.Moment = moment(),
) {
    const kboFlow: T[] = [];
    const recent: T[] = [];
    const last30: T[] = [];
    const months: { [key: string]: T[] } = {};

    Array.from(chatStores)
        .filter((chatStore) => visibleChatIds.includes(chatStore.chat.id))
        .forEach((chatStore) => {
            if (chatStore.chat.isKboFlowResearch) {
                kboFlow.push(chatStore);
                return;
            }

            const created = moment(chatStore.chat.createdOn);
            const daysAgo = now.diff(created, "days");

            if (daysAgo <= 7) {
                recent.push(chatStore);
            } else if (daysAgo <= 30) {
                last30.push(chatStore);
            } else {
                const monthKey = created.format("MMMM YYYY");
                if (!months[monthKey]) months[monthKey] = [];
                months[monthKey].push(chatStore);
            }
        });

    const sortNewestFirst = (a: T, b: T) =>
        moment(b.chat.createdOn).diff(moment(a.chat.createdOn));

    kboFlow.sort(sortNewestFirst);
    recent.sort(sortNewestFirst);
    last30.sort(sortNewestFirst);
    Object.keys(months).forEach((month) => {
        months[month].sort(sortNewestFirst);
    });

    return { kboFlow, recent, last30, months };
}
